import {ErrorHandler, Injectable} from '@angular/core';
import {environment} from '@environment';
import * as Sentry from '@sentry/browser';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() {
    Sentry.init({
      dsn: 'https://ee10026d9c5142abb8947a9643ff5078@sentry.io/1809715',
      release: `${environment.sentryReleaseName}@${environment.version}`,
      environment: environment.sentryEnvironment
    });
  }

  handleError(error) {
    if (this.filterError(error)) {
      const eventId = Sentry.captureException(error.originalError || error);
      if (environment.enableSentryReportDialog) {
        Sentry.showReportDialog({eventId});
      }
    }
    console.error(error);
  }

  filterError(error): boolean {
    return error?.message !== 'Unauthorized';
  }
}
